import React, { useState, useEffect } from "react";
import { Button, FormGroup, Label, Input } from "reactstrap";
import { useHistory, withRouter } from "react-router-dom";
import { createBrowserHistory } from "history";
import "./index.css";
import ApiCaller from "../../api/apiCaller";
import * as utils from "resources/utils"
import HRWConstant from 'constants/hrw';

interface UserValueProps {
  property: string;
  value: any;
}

export default function Login() {
  const history = createBrowserHistory();
  const search = window.location.search;
  const searchParams = new URLSearchParams(search);

  const [user, setUser] = useState({
    username: "",
    password: "",
    provider: "db",
  });
  const handleLoginData = async (res: any) => {
    utils.default.setCookies("access_token", res?.access_token)
    utils.default.setCookies("csrf_access_token", res?.csrf_access_token)

    // auto set company if login using sso
    if (res?.company_id) {
      utils.default.setCookies("company_id", res?.company_id)
    }

    const userRes = await ApiCaller.get('user/me');
    if (userRes.status === "ok") {
      utils.default.setCookies("user", JSON.stringify(userRes.data));
    }

    // Go to home
    history.push('/');
    window.location.reload();
  };
  const login = async () => {
    const res = await ApiCaller.post("user/login", user, undefined, true);
    if (res?.user) {
      handleLoginData(res);
    } else {
      alert(`Login failure. ${res?.message || res?.msg}`)
    }
  };
  const editUserValue = ({ property, value }: UserValueProps) => {
    setUser({ ...user, ...{ [property]: value } });
  };
  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      login();
    }
  };

  const loginWithHRV = () => {
    let authUrl = 'https://accounts.haravan.com/connect/authorize?';
    authUrl += `response_mode=${HRWConstant.responseMode}&response_type=${HRWConstant.responseType}`;
    authUrl += `&scope=${HRWConstant.scope_string}&client_id=${HRWConstant.clientId}`;
    authUrl += `&redirect_uri=${HRWConstant.redirectUri}&nonce=12frg5`;
    console.log(authUrl);
    window.location.href = authUrl;
  };

  useEffect(() => {
    const access_token = searchParams.get('access_token');
    const csrf_access_token = searchParams.get('csrf_access_token');
    const company_id = searchParams.get('company_id');
    if (access_token) {
      handleLoginData({ access_token, csrf_access_token, company_id });
    }
  }, [searchParams]);

  return (
    <div className="main-login-form">
      <FormGroup>
        <Label>Username</Label>
        <Input
          value={user?.username}
          type="email"
          placeholder="hello@datadex.vn"
          onChange={(e) =>
            editUserValue({ property: "username", value: e.target.value })
          }
        />
      </FormGroup>
      <FormGroup>
        <Label>Password</Label>
        <Input
          value={user?.password}
          type="password"
          placeholder="Password"
          onChange={(e) =>
            editUserValue({ property: "password", value: e.target.value })
          }
          onKeyDown={e => handleKeyDown(e)}
        />
      </FormGroup>
      <FormGroup>
        <Label />
        <Button block color="primary" onClick={login}>
          Login
        </Button>
      </FormGroup>
      <FormGroup>
        <Label />
        <Button block color="info" onClick={loginWithHRV}>
          Login using HRV account (Beta)
        </Button>
      </FormGroup>
    </div>
  );
}
